<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Nav, NavItem, NavLink } from "sveltestrap";
  import OrgPanel from "./OrgPanel.svelte";
  import type { OrganizationInfo } from "../helpers/orgTypes";

  export let orgInfo: OrganizationInfo[];
  let selectedOrg = orgInfo[0];
  const dispatch = createEventDispatcher();

  function onSelect(org: OrganizationInfo) {
    dispatch("orgSelected", {
      org: org,
    });

    selectedOrg = org;
  }
</script>

<Nav vertical pills>
  {#each orgInfo as org}
    <NavItem>
      <NavLink
        active={selectedOrg === org}
        style="text-align: left;"
        on:click={() => onSelect(org)}
      >
        <OrgPanel orgInfo={org} />
      </NavLink>
    </NavItem>
  {/each}
</Nav>
